export default __webpack_public_path__ + "static/media/003-facebook.2945036f.svg";